import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import es from './locales/es/translation.json';
import en from './locales/en/translation.json';
import esCommon from './locales/es/common.json';
import enCommon from './locales/en/common.json';
import esHome from './locales/es/home.json';
import enHome from './locales/en/home.json';
import esProfile from './locales/es/profile.json';
import enProfile from './locales/en/profile.json';
import esForum from './locales/es/forum.json';
import enForum from './locales/en/forum.json';
import esRooms from './locales/es/rooms.json';
import enRooms from './locales/en/rooms.json';
import esNatal from './locales/es/natal.json';
import enNatal from './locales/en/natal.json';
import esZodiacCrush from './locales/es/zodiacCrush.json';
import enZodiacCrush from './locales/en/zodiacCrush.json';
import esZodiacClash from './locales/es/zodiacClash.json';
import enZodiacClash from './locales/en/zodiacClash.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: es,
        common: esCommon,
        home: esHome,
        profile: esProfile,
        forum: esForum,
        rooms: esRooms,
        natal: esNatal,
        zodiacCrush: esZodiacCrush,
        zodiacClash: esZodiacClash,
      },
      en: {
        translation: en,
        common: enCommon,
        home: enHome,
        profile: enProfile,
        forum: enForum,
        rooms: enRooms,
        natal: enNatal,
        zodiacCrush: enZodiacCrush,
        zodiacClash: enZodiacClash,
      },
    },

    fallbackLng: 'en',

    supportedLngs: ['es', 'en'],
    ns: ['translation', 'common', 'home', 'profile', 'forum', 'rooms', 'natal', 'zodiacCrush', 'zodiacClash'],
    defaultNS: 'translation',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

export default i18n;
